import React from 'react';

export const UnauthorizedSvg: React.FC<{ className?: string }> = ({ className = 'w-72 h-48 sm:w-96 sm:h-64' }) => {
  return (
    <svg
      viewBox="0 0 500 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} mx-auto transition-all duration-300`}
    >
      {/* Background tracks */}
      <rect x="130" y="80" width="240" height="14" rx="7" fill="#E2E8F0" className="dark:fill-slate-800" />
      <rect x="90" y="115" width="320" height="14" rx="7" fill="#F1F5F9" className="dark:fill-slate-800/60" />
      <rect x="160" y="150" width="180" height="14" rx="7" fill="#E2E8F0" className="dark:fill-slate-800" />

      {/* First "4" */}
      <path
        d="M165 90 L125 170 H175 V205"
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-slate-900 dark:text-white"
      />
      <path
        d="M175 130 H110"
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        className="text-slate-900 dark:text-white"
      />

      {/* Keyhole Center "0" */}
      <g transform="translate(250, 140)">
        <circle
          r="44"
          stroke="currentColor"
          strokeWidth="16"
          fill="none"
          className="text-slate-900 dark:text-white"
        />
        <circle cx="0" cy="-10" r="12" fill="#0066b2" className="dark:fill-blue-500" />
        <path d="M-8 -5 L8 -5 L12 25 L-12 25 Z" fill="#0066b2" className="dark:fill-blue-500" />
      </g>

      {/* "1" */}
      <path
        d="M320 110 L340 90 V205"
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-slate-900 dark:text-white"
      />
    </svg>
  );
};

export default UnauthorizedSvg;
